<perfect-scrollbar style="max-height: calc(100% - 20px)">
  <mat-card class="logo-card container">
    <div class="d-md-none row d-flex justify-content-center align-items-center">
      <a [href]="href_logo" class="col-auto pr-0">
        <img [src]="topCardImg" style="height: 70px; margin: -10px 0px" />
      </a>

      <div
        class="info-header-card col mat-elevation-z0 d-flex align-items-center justify-content-end"
      >
        <div>
          <div
            class="row d-flex align-items-center justify-content-center m-0"
            (click)="openAbout()"
          >
            <span style="color: white">Powered by</span
            ><span style="color: rgb(111, 194, 233)">AQUASAFE</span>
            <i class="fad fa-arrow-alt-circle-right theme-fa-accent ml-1"></i>
          </div>
          <div
            class="row d-flex align-items-center justify-content-center m-0 mr-1"
            style="color: white"
          >
            <share-buttons
              *ngIf="allowSharing"
              [theme]="'modern-light'"
              [include]="['facebook', 'twitter', 'linkedin']"
              [show]="3"
              [size]="-4"
              (opened)="onOpenedChanged($event)"
            ></share-buttons>
          </div>
        </div>
      </div>
    </div>

    <a class="d-none d-md-block" style="margin: -10px" [href]="href_logo">
      <img [src]="sideCardImg" style="max-height: 200px; width: 100%" />
    </a>

    <div
      class="row d-flex align-items-center justify-content-center smaller-info m-0"
      style="color: white; padding-top: 15px"
    >
      Toda a informação é apresentada em hora local.
    </div>
  </mat-card>

  <mat-card
    class="info-side-card d-none d-md-block"
    style="text-align: center; cursor: pointer"
  >
    <div
      class="row d-flex align-items-center justify-content-center m-0"
      (click)="openAbout()"
    >
      <span style="color: white">Powered by</span
      ><span style="color: rgb(111, 194, 233)">AQUASAFE</span>
      <i class="fad fa-arrow-alt-circle-right theme-fa-accent ml-1"></i>
    </div>
    <hr *ngIf="allowSharing" class="m-1" />
    <div
      *ngIf="allowSharing"
      class="row d-flex align-items-center justify-content-center m-0 mr-1"
      style="color: white"
    >
      <span>Partilhar:</span>
      <share-buttons
        [theme]="'modern-light'"
        [include]="['facebook', 'twitter', 'linkedin']"
        [show]="3"
        [size]="-4"
      >
      </share-buttons>
    </div>
  </mat-card>

  <mat-card class="custom-card">
    <mat-card-title class="sub-title-negative d-none d-md-block">{{
      title
    }}</mat-card-title>
    <hr class="d-none d-md-block" />
    <mat-card-content class="container-fluid pr-1 pl-1">
      <div
        class="row d-flex justify-content-center align-items-center"
        [ngClass]="isModeled ? '' : 'modeled-box'"
      >
        <div
          class="row col-6 col-sm-6 col-md-12 d-flex justify-content-center align-items-center"
        >
          <div
            *ngIf="!isModeled"
            class="col-12 row d-flex justify-content-center align-items-center mt-3 mb-3"
          >
            <b class="small-info-bold">Valor medido </b>
            <span class="small-info">
              a {{ lastValuesDate | date : "dd/MM/yyyy 'às' HH:mm" : "en" }}
              <i
                  class="fas fa-exclamation-triangle ml-2"
                  *ngIf="!isDataUnderTolerance()"
                  matTooltip="A comunicação com a fonte de dados encontra-se temporariamente indisponível"
                  style="color: #FFD43B; cursor: pointer"
              ></i>
            </span>
          </div>
          <div
            *ngIf="isModeled"
            class="col-12 row d-flex justify-content-center align-items-center small-info mt-3 mb-3"
          >
            <b class="small-info-bold">Valor previsto </b>
            <span class="small-info"
              >para {{ lastValuesDate | date : "dd/MM/yyyy 'às' HH:mm" : "en" }}
            </span>
          </div>
          <div
            class="col-12 mt-3 row d-flex justify-content-center align-items-center p-0"
          >
            <i
              [ngClass]="getWeatherStateIcon(weatherState)"
              style="color: white; font-size: 35px"
            ></i>
            <span style="color: white; font-size: 25px">
              {{ temperatureSerie | getSerieValue }}
            </span>
          </div>
        </div>
        <div
          class="row col-6 mt-3 col-sm-6 col-md-12 d-flex justify-content-center align-items-center"
        >
          <span class="col-12 small-info mt-2 p-2" style="text-align: center;"
            >Temperatura do ar
          </span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-expansion-panel
    *ngIf="projects && projects.length > 0"
    hideToggle
    class="custom-card custom-expansion-panel"
  >
    <mat-expansion-panel-header class="custom-expansion-panel-header">
      <mat-panel-title
        class="row d-flex justify-content-between align-items-center m-0 ml-2 mr-3"
      >
        Outras Estações
        <i class="far fa-chevron-down" style="font-size: 12px"></i>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div *ngFor="let project of projects" style="padding: 5px 0">
      <a [href]="project.url">{{ project.name }}</a>
    </div>
  </mat-expansion-panel>
</perfect-scrollbar>
